module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-wht",
    attrs: {
      "id": "financial-profile-items"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', [(_vm.loading) ? _c('loader') : (!_vm.loading && _vm.crud) ? _c('div', [_c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Label")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.label),
      expression: "entity.label"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.entity.label)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "label", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "key"
    }
  }, [_vm._v("Key Field")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.keyField),
      expression: "entity.keyField"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "key",
      "type": "text"
    },
    domProps: {
      "value": (_vm.entity.keyField)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "keyField", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "default-value"
    }
  }, [_vm._v("Default Value")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.defaultValue),
      expression: "entity.defaultValue"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "default-value",
      "type": "text"
    },
    domProps: {
      "value": (_vm.entity.defaultValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "defaultValue", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-top": "26px"
    }
  }, [_c('div', {
    staticClass: "btn btn-success sq",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n                Save\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-danger sq",
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("\n                Clear\n              ")])])])]) : (!_vm.loading && !_vm.crud) ? _c('div', [_c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, _vm._l((_vm.items), function(item) {
    return _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "form-label",
      attrs: {
        "for": item.keyField
      }
    }, [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.keyFields[item.keyField]),
        expression: "keyFields[item.keyField]"
      }],
      staticClass: "form-control",
      attrs: {
        "id": item.keyField,
        "type": "text"
      },
      domProps: {
        "value": (_vm.keyFields[item.keyField])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.keyFields, item.keyField, $event.target.value)
        }
      }
    })])
  }), 0)]) : _vm._e()], 1)])]), _vm._v(" "), (!_vm.loading && _vm.crud) ? _c('div', [_c('vue-table', {
    attrs: {
      "tableData": _vm.items,
      "fields": _vm.itemFields,
      "show-edit": true,
      "show-delete": true
    },
    on: {
      "table-edit-request": _vm.edit,
      "table-delete-request": _vm.remove
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btn btn-primary sq",
    on: {
      "click": _vm.go
    }
  }, [_vm._v("\n      Test With Defaults\n    ")])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44425985"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/admin/components/Report/ReportParameters.vue
// module id = 2170
// module chunks = 1